import { VStack, Span } from "@chakra-ui/react"
import SearchCombobox from "./SearchCombobox"

export type CustomerItem = {
  id: string
  name: string
  sites: Array<{
    id: string
    name: string
  }>
}

interface CustomersOnlyComboboxProps {
  onItemSelection?: (value: CustomerItem | undefined) => void
  initialValue?: CustomerItem
  value?: CustomerItem | null
  disabled?: boolean
  required?: boolean
  CreateAction?: () => React.ReactNode
  onInputChange?: (value: string) => void
}

/**
 * Combobox for selecting customers only (not flattened with sites).
 * Used when you need to select a customer first before selecting one of their sites.
 */
const CustomersOnlyCombobox = ({
  onItemSelection,
  initialValue,
  value,
  disabled = false,
  required,
  CreateAction,
  onInputChange,
}: CustomersOnlyComboboxProps) => {
  console.log("hello", initialValue)
  return (
    <SearchCombobox<CustomerItem>
      queryType="customersOnly"
      onItemSelection={onItemSelection}
      label="customers"
      formatSelectedItem={(item) => item.name}
      initialValue={initialValue}
      value={value}
      disabled={disabled}
      required={required}
      onInputChange={onInputChange}
      itemContent={(item) => (
        <VStack gap={0} width="100%" align="start">
          <Span width="100%" textStyle="sm" fontWeight="medium">
            {item.name}
          </Span>
          {item.sites && item.sites.length > 0 && (
            <Span width="100%" textStyle="xs" color="fg.muted">
              {item.sites.length} site{item.sites.length !== 1 ? "s" : ""}
            </Span>
          )}
        </VStack>
      )}
      CreateAction={CreateAction}
    />
  )
}

export default CustomersOnlyCombobox
